export class CustomAttributeValue {
  attributeKey: string;
  attributeName: string;
  attributeValue: string;
  attributeTranslatedValue: string;
  attributeQuantity: number;
  attributeBasePrice: number;
  attributeEnabled: boolean;

  // Declaration overloads (either none or all)
  constructor();
  constructor(data: CustomAttributeValue);
  // Actual runtime (implementation)
  constructor(data?: Partial<CustomAttributeValue>) {
    // If data is provided, initialize with those values, otherwise use default values
    this.attributeKey = data?.attributeKey ?? '';
    this.attributeName = data?.attributeName ?? '';
    this.attributeValue = data?.attributeValue ?? '';
    this.attributeTranslatedValue = data?.attributeTranslatedValue ?? '';
    this.attributeQuantity = data?.attributeQuantity ?? 0;
    this.attributeBasePrice = data?.attributeBasePrice ?? 0;
    this.attributeEnabled = data?.attributeEnabled ?? true;
  }
}
export type CustomAttributeValues = CustomAttributeValue[];

export interface CustomAttributeValueDTO {
  attributeKey: string;
  attributeName: string;
  attributeValue: string;
  attributeTranslatedValue: string;
  attributeQuantity: number;
  attributeBasePrice: number;
  attributeEnabled: boolean;
}

export const toDTO = (x: CustomAttributeValue): CustomAttributeValueDTO => ({
  attributeKey: x.attributeKey,
  attributeName: x.attributeName,
  attributeValue: x.attributeValue,
  attributeTranslatedValue: x.attributeTranslatedValue,
  attributeQuantity: x.attributeQuantity,
  attributeBasePrice: x.attributeBasePrice,
  attributeEnabled: x.attributeEnabled,
});

export const fromDTO = (dto: CustomAttributeValueDTO): CustomAttributeValue => {
  const cv = new CustomAttributeValue();
  cv.attributeKey = dto.attributeKey;
  cv.attributeName = dto.attributeName;
  cv.attributeValue = dto.attributeValue;
  cv.attributeTranslatedValue = dto.attributeTranslatedValue;
  cv.attributeQuantity = dto.attributeQuantity;
  cv.attributeBasePrice = dto.attributeBasePrice;
  cv.attributeEnabled = dto.attributeEnabled;
  return cv;
};
